enum FeeState {
    Created = "CREATED",
    Pending = "PENDING",
    Paid = "PAID",
    Failed = "FAILED",
}
export default FeeState